export default __webpack_public_path__ + "static/media/contacto.9b2ba92a.jpg";